"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderShell = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
var ImageInputContext_1 = require("../../../../ImageInputContext");
var calcAspectRatio_1 = require("../../../ImageEditor/utils/calcAspectRatio");
var themes_1 = require("../../../../../../themes");
var icons_1 = require("../../../../../../icons");
var Typo_1 = require("../../../../../Typo");
var greyColor80 = themes_1.colors.greyColor80;
var CaretLeft = icons_1.icons.CaretLeft, CaretRight = icons_1.icons.CaretRight;
var SliderShell = function (_a) {
    var value = _a.value, activeIdx = _a.activeIdx, setActiveIdx = _a.setActiveIdx, render = _a.render;
    var _b = (0, ImageInputContext_1.useImageInputContext)(), aspectRatio = _b.aspectRatio, isLoading = _b.isLoading, imageUnderEdit = _b.imageUnderEdit;
    var _c = (0, react_1.useState)(false), isHeightSet = _c[0], setIsHeightSet = _c[1];
    var wrapperRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(undefined), imageMinusCaptionHeight = _d[0], setImageMinusCaptionHeight = _d[1];
    var updateHeight = function () {
        if (wrapperRef.current) {
            setImageMinusCaptionHeight(wrapperRef.current.clientWidth / (0, calcAspectRatio_1.calcAspectRatio)(aspectRatio));
            setIsHeightSet(true);
        }
    };
    (0, react_1.useEffect)(function () {
        updateHeight();
        window.addEventListener('resize', updateHeight);
        var intervalId = setInterval(function () {
            // to avoid issues in cases where height is initally 0 because parent block has display:hidden condition on initial render
            if (!isHeightSet) {
                updateHeight();
            }
            else {
                clearInterval(intervalId);
            }
        }, 100);
        return function () {
            window.removeEventListener('resize', updateHeight);
            intervalId && clearInterval(intervalId);
        };
    }, []);
    return (react_1.default.createElement(styled_1.StyledFlexWrapper, { ref: wrapperRef },
        value.map(function (v, idx) { return (react_1.default.createElement(styled_1.StyledFlexItem, { key: (v === null || v === void 0 ? void 0 : v.publicUrl) || idx, marginLeft: idx === 0 && activeIdx * -100 + "%" }, render(v, idx) /* explicitly called, cuz we want an error to throw if render prop aint passed thru */)); }),
        !isLoading && value.length > 1 && !imageUnderEdit && react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(styled_1.StyledCaretLeft, { onClick: function () {
                    return setActiveIdx(activeIdx > 0 ? activeIdx - 1 : value.length - 1);
                }, imageMinusCaptionHeight: imageMinusCaptionHeight },
                react_1.default.createElement(CaretLeft, { weight: "duotone", size: 45, color: greyColor80 })),
            react_1.default.createElement(styled_1.StyledCaretRight, { imageMinusCaptionHeight: imageMinusCaptionHeight, onClick: function () {
                    return setActiveIdx(activeIdx < value.length - 1 ? activeIdx + 1 : 0);
                } },
                react_1.default.createElement(CaretRight, { weight: "duotone", size: 45, color: greyColor80 })),
            react_1.default.createElement(styled_1.StyledXOfY, { imageMinusCaptionHeight: imageMinusCaptionHeight },
                react_1.default.createElement(Typo_1.SANS_3, null, activeIdx + 1 + "/" + value.length)))));
};
exports.SliderShell = SliderShell;
